import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "Juices", href: "#juices" },
  { label: "How to Order", href: "#order" },
  { label: "Recipes", href: "#recipes" },
  { label: "Why Cold Pressed", href: "#why" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-md bg-[#FFF8F0]/85 border-b border-[#FF7A1A]/10 shadow-[0_6px_20px_rgba(26,26,26,0.05)]" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
          <img src="/holly-logo.png" alt="Holly's Juices" className="h-11 sm:h-12 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[15px] font-semibold text-[#1A1A1A]/80 hover:text-[#FF7A1A] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#order"
            className="hidden sm:inline-flex items-center rounded-full bg-[#FF7A1A] hover:bg-[#FFC93C] hover:text-[#1A1A1A] text-white font-bold text-sm px-5 py-2.5 transition-all duration-300 shadow-[0_8px_20px_rgba(255,122,26,0.35)] active:scale-95"
            data-testid="nav-order-btn"
          >
            Order Now
          </a>
          <button
            className="lg:hidden p-2 rounded-full text-[#1A1A1A]"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            <div className="space-y-1.5">
              <span className="block w-6 h-0.5 bg-[#1A1A1A]" />
              <span className="block w-6 h-0.5 bg-[#1A1A1A]" />
              <span className="block w-4 h-0.5 bg-[#1A1A1A]" />
            </div>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FFF8F0] border-t border-[#FF7A1A]/10 px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-semibold text-[#1A1A1A]/80 py-1.5"
            >
              {l.label}
            </a>
          ))}
          <a href="#order" onClick={() => setOpen(false)} className="mt-2 text-center rounded-full bg-[#FF7A1A] text-white font-bold px-5 py-3">
            Order Now
          </a>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
